import {get, post, put} from "../services/common.services";

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The arguments we want to pass to "Axios"
 *
 * @return {object}           The response data
 */
export default function request<T>(args: any) {
  if (
    (args[0] !== "LOGIN" &&
      args[0] !== "MANAGE" &&
      args[0] !== "SEARCH" &&
      args[0] !== "RECENT" &&
      args[0] !== "APP" &&
      args[1] !== "FETCH_SEARCH_LOADS" &&
      args[0] !== "MYLOAD" &&
      args[0] !== "DRIVERS_LIST" &&
      args[0] !== "LOCATION_TRACKER" &&
      args[0] !== "FETCH_USER_DETAILS" &&
      args[0] !== "FETCH_USER_DETAILS_NEW" &&
      args[0] !== "REGISTER_DEVICE" &&
      args[0] !== "MORETAB" &&
      args[0] !== "FAVORITE" &&
      args[0] !== "SUBMITFEEDBACK" &&
      args[0] !== "HOME" &&
      args[0] !== "COUNTRY_CODES" &&
      args[0] !== "USER" &&
      args[0] !== "GET_PREDECESSOR" &&
      args[1] !== "CONTENTORCONFIG" &&
      args[0] !== "DOCUMENT" &&
      args[1] !== "GET_PREFERENCE" &&
      args[1] !== "POST_PREFERENCE" &&
      args[1] === "GET_NOTIFICATION") ||
      args[1] === "TERMS_AND_CONDITION" || args[1] === "CONTACT_US" || args[1] === "PCMILLER"
  ) {
    return get(args[0], args[1], args[2]);
  } else if (
    args[1] === "UPDATE_DELETE_NOTIFICATION" ||
    args[1] === "UPDATE_NEW_TO_UNREAD_NOTIFICATION"
  ) {
    return put(
      args[0],
      args[1],
      args[2],
      args[3],
      args[4],
      args[5]
    );
  } else {
    return post(
      args[0],
      args[1],
      args[2],
      args[3],
      args[4],
      args[5]
    );
  }
}
